import type { CSSProperties } from 'react';
import type { Character } from '@/constants/characters';

export type FluffyCreaturePalette = Pick<Character, 'primaryColor' | 'secondaryColor' | 'accentColor'>;

interface FluffyCreatureAvatarProps extends FluffyCreaturePalette {
  className?: string;
  scale?: number;
  style?: CSSProperties;
}

const FluffyCreatureAvatar = ({
  primaryColor,
  secondaryColor,
  accentColor,
  className,
  scale = 1,
  style
}: FluffyCreatureAvatarProps) => {
  const creatureStyle = {
    '--primary-color': primaryColor,
    '--secondary-color': secondaryColor,
    '--accent-color': accentColor,
    ...(scale !== 1 ? { transform: `scale(${scale})` } : {}),
    ...style
  } as CSSProperties;

  return (
    <div className={className ? `fluffy-creature ${className}` : 'fluffy-creature'} style={creatureStyle}>
      <div className="creature-ears">
        <div className="creature-ear left"></div>
        <div className="creature-ear right"></div>
      </div>
      <div className="creature-body-fluffy">
        <div className="creature-eyes-large">
          <div className="eye-large left"></div>
          <div className="eye-large right"></div>
        </div>
      </div>
      <div className="creature-hands">
        <div className="creature-hand left"></div>
        <div className="creature-hand right"></div>
      </div>
      <div className="creature-feet">
        <div className="creature-foot left"></div>
        <div className="creature-foot right"></div>
      </div>
    </div>
  );
};

export default FluffyCreatureAvatar;
